import React, { useEffect, useState } from 'react';
import CommonHeader from '../../components/HeaderComponent/CommonHeader';
import NotificationFilters from '../../container/pooling-notifications/NotificationFilters';
import NotificationMainTable from '../../container/pooling-notifications/NotifcationMainTable';
import { Divider, Pagination } from 'antd';
import '../../css/pooling-notification.css';
import { useDispatch, useSelector } from 'react-redux';
import { notificationList } from '../../features/AutoPooling/AutoPoolingSlice';

const PoolingNotification = () => {
    const dispatch = useDispatch();
    const { NotificationListData, totalNotifications } = useSelector((state) => state.autoPooling); // Assuming `totalNotifications` comes from the backend
    const [currentPage, setCurrentPage] = useState(1);
    const [activeFilter, setActiveFilter] = useState('all');
    const [activeDateFilter, setActiveDateFilter] = useState('');


    const dateFilterOptions = [
        {
            value: '',
            label: 'All Days'

        },
        {
            value: 7,
            label: 'Last 7D'

        },
        {
            value: 30,
            label: 'Last 30D'

        },
    ];


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    useEffect(()=>{
        if(currentPage){
            dispatch(notificationList({ 
                request_type: activeFilter, 
                requested_page_number: currentPage,
                period: activeDateFilter 
            }));
        }
    },[currentPage,activeFilter,activeDateFilter])

    return (
        <div className="pooling-notification-container main-board">
            <CommonHeader 
                headerKey="pooling_notification" 
                headerTitle="Notifications" 
                // headerSubTitle="Review and accept or decline generated pool requests here." 
                type="notifications"
            />
            <div className='notification-body'>
                <NotificationFilters 
                    currentPage={currentPage} 
                    setCurrentPage={setCurrentPage}
                    activeFilter={activeFilter}
                    setActiveFilter={setActiveFilter}
                    activeDateFilter={activeDateFilter}
                    setActiveDateFilter={setActiveDateFilter}
                    dateFilterOptions={dateFilterOptions}
                />
                {/* <Divider style={{margin:"0px"}} /> */}
                {NotificationListData?.notification_list && NotificationListData?.notification_list.length > 0 
                    ? <NotificationMainTable 
                        data={NotificationListData?.notification_list} 
                        currentPage={currentPage} 
                        setCurrentPage={setCurrentPage}
                        activeFilter={activeFilter}
                        setActiveFilter={setActiveFilter}
                        activeDateFilter={activeDateFilter}
                        setActiveDateFilter={setActiveDateFilter}
                        dateFilterOptions={dateFilterOptions}
                        
                    /> 
                    : <h1 className='pooling-notification-no-data'>No Pool Requests</h1>
                }
                {NotificationListData?.pagination?.pagination_info ? (
                    <div className="pagination-container-notification">
                        <Pagination
                            current={NotificationListData?.pagination?.pagination_info?.current_page}  
                            total={NotificationListData?.pagination?.pagination_info?.total_items}  
                            pageSize={NotificationListData?.pagination?.pagination_info?.items_per_page}  
                            onChange={handlePageChange} 
                            showSizeChanger={false} 
                            showQuickJumper
                            
                        />
                    </div>
                ) : ""}
            </div>
        </div>
    );
};

export default PoolingNotification;
